<template>
  <header class="accruals-workspace-header" data-testid="accruals-data-page__header">
    <div class="accruals-workspace-header__nav d-flex align-center">
      <base-button
        icon-style
        small
        class="shadow-off accruals-workspace-header__back-btn"
        image="/img/icons/fbc-icons/BackArrow.svg"
        image-alt="Back"
        aria-label="Back to accruals"
        data-testid="accruals-data-page__back-btn"
        @click="$emit('back')"
      />

      <nav
        class="accruals-workspace-header__breadcrumb d-flex align-center"
        aria-label="Breadcrumb"
        data-testid="accruals-data-page__breadcrumb"
      >
        <button
          type="button"
          class="accruals-workspace-header__breadcrumb-link"
          data-testid="accruals-data-page__back-link"
          @click="$emit('back')"
        >
          Back to accruals
        </button>
      </nav>
    </div>

    <div class="accruals-workspace-header__title-block">
      <div class="accruals-workspace-header__title-row">
        <h1 class="accruals-workspace-header__title">{{ title }}</h1>
        <v-tooltip v-if="showRefresh" bottom content-class="tooltip-bottom">
          <template #activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              icon
              class="accruals-workspace-header__refresh-btn shadow-off"
              :loading="refreshLoading"
              :disabled="refreshLoading"
              aria-label="Refresh data"
              data-testid="accruals-data-page__refresh-btn"
              v-on="on"
              @click="$emit('refresh')"
            >
              <v-icon size="20" data-testid="accruals-data-page__refresh-icon">mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Refresh</span>
        </v-tooltip>
      </div>
      <p v-if="subtitle" class="accruals-workspace-header__subtitle">{{ subtitle }}</p>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AccrualsWorkspaceHeader',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    showRefresh: { type: Boolean, default: false },
    refreshLoading: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsWorkspaceHeader.scss';
</style>
